import authInterceptor from "../AuthInterceptor";

export const EscalationCompletedAPI = {
  // getEscalationList: () =>
  //     authInterceptor.get(`ranking-api/escalation-complete-list/`)
  //         .then((response) => response.data)
  //         .catch((error) => error.response),
  getEscalationList: (config = {}) =>
    authInterceptor
      .get(`ranking-api/escalation-complete-list/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  escalationListFilter: (bodyData) =>
    authInterceptor
      .post(`ranking-api/escalation-complete-list/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  exportEscalationList: (config = {}) =>
    authInterceptor
      .get(`ranking-api/escalation-complete-list/`, {
        ...config,
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => Promise.reject(error)),
};
